import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { RAZORPAY_KEY } from '../../config/api_config';
import { generateOrderId, generateRazorpayTranscript, getPricingProducts, getHigestDiscount, createLeadScore, getPricingGoal } from '../../redux/actions/pricing';
import { toast } from 'react-toastify';
import PricingAnnual from './PricingAnnual';
import PricingCoins from './PricingCoins';
import PricingMonthly from './PricingMonthly';
import { IKImage } from 'imagekitio-react';
import useRazorpay from 'react-razorpay';
import { refreshUserCoins } from '../../redux/actions/profileDetails';
import { getLeads } from '../../redux/actions/userSubscription';
import CompletionModal from './CompletionModal';
import DynamicMeta from '../../components/DynamicMeta';
import Constants, { leadScoringActivity } from '../../common/constants';
import { Mixpanel } from '../../config/Mixpanel';
import ReactPixel from 'react-facebook-pixel';
import EntryPopUp from './EntryPopUp';
import { SET_IS_WHATSAPP } from '../../redux/actions/types';
import ZohoSalesIQ from '../../components/ZohoSalesIQ';
import GoogleOneTapLogin from '../../components/GoogleOneTap';


export default function PricingPage({route}) {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const thankyou = searchParams.get("thankyou")
  const coin_id = searchParams.get("coin_id")
  const dispatch = useDispatch()
  const user_token = useSelector(store => store?.authentication?.user_token)
  const user_name = useSelector(store => store?.profileDetails?.name)
  const email = useSelector(store => store?.profileDetails?.email)
  const phone_number = useSelector(store => store?.profileDetails?.['phone-number'])
  const id = useSelector(store => store?.profileDetails?.id)
  const location = useLocation()
  const navigate = useNavigate()
  const [urlParams] = useSearchParams()
  const Razorpay = useRazorpay()
  const [discountTime, setDiscountTime] = useState(0);
  const [scrollToMax , setScrollToMax] = useState(0);
  const [scrollToProMonthly , setScrollToProMonthly] = useState(0);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const userToggle = true;
  const [isCareerGoal, setIsCareerGoal] = useState({
    is_show: false,
    selected_goal: { goal_name: "Placements", product: "LearnTube Max" },
  });

  const [isSetGoal , setIsSetGoal ] = useState(false);

  // const [productName, setProductName] = useState("")

  // useEffect(() => {
  //     dispatch(getPricingProducts(urlParams.get("type") ? urlParams.get("type") : 'subscription', successObj => {
  //         setProducts(successObj)
  //     }))

  // }, [])

  useEffect(() => {
    if (id) {
      dispatch(getLeads({ user_id: id, is_visit: true }))
      dispatch(createLeadScore(id, leadScoringActivity.VISITED_PRICING_PAGE.type))
      Mixpanel.track(Constants.Mixpanel.PRICING_PAGE_VISIT, {
        distinct_id: email
      })
    }
  }, [])

  
  useEffect(()=>{
    if(userToggle){
      setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal :{ goal_name :'Placements' , product:"LearnTube Max"}}));
    }
  },[])

  // useEffect(()=>{

  //   if(searchParams.get("is_show")  && searchParams.get("selected_goal") ){
      

  //     switch (searchParams.get("selected_goal")) {
  //       case "LearnTube Pro":
  //         setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal:{ goal_name : 'Certifications' , product : "LearnTube Pro" }}))
  //         break;
  //       case "LearnTubeX":
  //         setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal:{ goal_name : 'Practical Learning' , product: "LearnTubeX" }}))
  //         break;
  //       case "LearnTube Max":
  //         setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal:{ goal_name :'Placements' , product:"LearnTube Max" }}))
  //         break;
  //       default:
  //         break;
  //     }
  //     console.log('route' , searchParams.get("is_show")  , searchParams.get("selected_goal") )
  //   }
  // },[])
  
  useEffect(() => {

    if(searchParams.get("source") && searchParams.get("source") === "wa" ){

      dispatch({type : SET_IS_WHATSAPP, payload : true});
    }

    dispatch(getHigestDiscount(id, (successObj) => { setDiscountTime(successObj?.expires_at); }
    ));
    
    if(user_role===7 && !searchParams.get("is_show")){
      dispatch(getPricingGoal((successObj)=>{
        if(successObj?.result === 'success'){
          setIsSetGoal(true);
          if(successObj?.data?.product_plans_id === 1){
            setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal : { goal_name : 'Certifications' , product : "LearnTube Pro", product_plans_id : 1 }}))
          }
          else if(successObj?.data?.product_plans_id === 4){
            setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal :  {goal_name : 'Practical Learning' , product: "LearnTubeX" ,product_plans_id : 4}}))
          }
          else{
            setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal :{ goal_name :'Placements' , product:"LearnTube Max", product_plans_id : 2}}))
          }

      }
      } , (errorObj)=>{}))
    }

  }, [])

  useEffect(()=>{
    ReactPixel.pageView();
  },[])

  //  console.log(discountTime);
  //  console.log(type);
  //  console.log(thankyou);

  const [coinBought, setCoinBought] = useState('');
  const razorpayHandler = ((e, callback) => {
    //console.log(e);
    dispatch(generateOrderId(user_token, e, successObj => {

      // console.log({ successObj })
    
      setCoinBought(successObj?.product_details?.product_name);
      const options = {
        key: RAZORPAY_KEY,
        amount: `${successObj?.product_details?.cost * 100}`,
        currency: "INR",
        name: successObj?.product_details?.product_name,
        description: successObj?.product_details?.product_description_short,
        image: successObj?.product_details?.pp_product_image?.url,
        order_id: successObj?.razorpay_order_id,
        modal: {
          "ondismiss": function () {
            callback()
          }
        },
        handler: (res) => {
          getOrderStatusSuccess(res)
          callback();
        },
        prefill: {
          name: user_name,
          email: email,
          contact: phone_number,
        },
        // notes: {
        //     address: "Razorpay Corporate Office"
        // },
        theme: {
          color: "#26CBA7"
        }
      }


      const razorpayInitializor = new Razorpay(options)

      razorpayInitializor.on("payment.failed", function (response) {
        getOrderStatusFailure(response)
        callback()
      });

      razorpayInitializor.open()

    }))

  })

  function getOrderStatusSuccess(response) {
    dispatch(generateRazorpayTranscript(
      user_token,
      {
        payment_id: response?.razorpay_payment_id,
        order_id: response?.razorpay_order_id,
        isError: false,
        razorpay_signature: response?.razorpay_signature,
        errorObj: {}
      },
      (successObj) => {
        if (type === "coin") {
          
          dispatch(refreshUserCoins(id))
          dispatch(createLeadScore(id, leadScoringActivity.PURCHASED_COINS.type ,response?.razorpay_order_id))
          Mixpanel.track(Constants.Mixpanel.PURCHASED_COINS , {
            distinct_id: email
          })
        }
        toast.success("Awesome! You Just Bought a Subscription")
        if (type === "coin") {
          setTimeout(() => {
            navigate(`/pricing?type=coin&coin_id=${coinBought}&thankyou=true`)
            window.location.reload();
            
          }, 3000)
        }
        else {
          dispatch(createLeadScore(id, leadScoringActivity.PURCHASED_SUBSCRIPTION.type,response?.razorpay_order_id))
          Mixpanel.track(Constants.Mixpanel.PURCHASED_SUBSCRIPTION , {
            distinct_id: email
          })
          setTimeout(() => {
            navigate('/pricing?thankyou=true')
            window.location.reload();
          },
            3000)
        }
      }
    ))
    // console.log(response)
  }

  function getOrderStatusFailure(response) {
    dispatch(generateRazorpayTranscript(
      user_token,
      {
        payment_id: response?.error?.metadata?.payment_id,
        order_id: response?.error?.metadata?.order_id,
        isError: true,
        razorpay_signature: "",
        errorObj: { ...response?.error }
      },
      successObj => {
        toast.error("something went wrong. Please try again later")
      }
    ))
    // console.log(response)
  }
  // const DynamicMeta = () => (
  //   <DynamicMeta
  //     title={'Career with LearnTubeX | Job Placement | CV Building | Bootcamp'}
  //     description="Upgrade with unlimited certificates for 200+ skills, CV building, Job placement with 900+ hiring partners, and live workshops."
  //   />
  // );

  if (type === 'annual' || type === null) {
    return (
      <>
        <DynamicMeta
          title={
            'Career with LearnTubeX | Job Placement | CV Building | Bootcamp'
          }
          description="Upgrade your career with unlimited courses and certificates in over 1240 topics. Get live feedback, CV building, interview training, and job placement support with 900+ hiring partners."
        />
        {!user_id && <GoogleOneTapLogin/>}
        <EntryPopUp 
        setScrollToMax={setScrollToMax}
        isCareerGoal={isCareerGoal}
        setIsCareerGoal={setIsCareerGoal}
        userToggle={userToggle}
        is_show={searchParams.get("is_show")}
        selected_goal={searchParams.get("selected_goal")}
        isSetGoal={isSetGoal}
        />
        {user_id && <ZohoSalesIQ/>}
        <PricingAnnual
          product_type={'subscription'}
          discountTime={discountTime}
          subscription_type={'annual'}
          razorpayHandler={razorpayHandler}
          thankyou={thankyou}
          route={route}
          scrollToMax={scrollToMax}
          scrollToProMonthly={scrollToProMonthly}
          setScrollToProMonthly={setScrollToProMonthly}
          isCareerGoal={isCareerGoal}
          setIsCareerGoal={setIsCareerGoal}
          userToggle={userToggle}
          
        />
      </>
    );
  }
  else if (type === 'monthly') {

    return (
      <>
        <DynamicMeta
          title={
            'Career with LearnTubeX | Job Placement | CV Building | Bootcamp'
          }
          description="Achieve career success with 1000s of free courses and certifications by top experts. Get live feedback, placement, and interview training with LearnTube's 1000+ hiring partners."
        />
        <EntryPopUp/>
        {!user_id && <GoogleOneTapLogin/>}
        {user_id && <ZohoSalesIQ/>}
        <PricingMonthly
          product_type={'subscription'}
          subscription_type={'monthly'}
          razorpayHandler={razorpayHandler}
          route={route}
        />
      </>
    );

  }
  else if (type === 'coin') {
    return (
      <>
        <DynamicMeta
          title={
            'Career with LearnTubeX | Job Placement | CV Building | Bootcamp'
          }
          description="Achieve career success with 1000s of free courses and certifications by top experts. Get live feedback, placement, and interview training with LearnTube's 1000+ hiring partners."
        />
        {/* <ZohoSalesIQ/> */}

        <PricingCoins
          product_type={'coin'}
          discountTime={discountTime}
          subscription_type={''}
          razorpayHandler={razorpayHandler}
          thankyou={thankyou}
          coin_id={coin_id}
          route={route}
        />
      </>
    );
  }

}